// @ts-nocheck
/* eslint-disable */
export const closeIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.0033 9.41751L12.9406 14.3548L14.3548 12.9406L9.41751 8.0033L14.3564 3.06441L12.9422 1.65019L8.0033 6.58908L3.06363 1.64941L1.64941 3.06363L6.58908 8.0033L1.651 12.9414L3.06521 14.3556L8.0033 9.41751Z" fill="currentColor"/></svg>`,
    name: 'close' as const
};